import { render, staticRenderFns } from "./FeatureTabs.vue?vue&type=template&id=5e4fe026&"
import script from "./FeatureTabs.vue?vue&type=script&lang=js&"
export * from "./FeatureTabs.vue?vue&type=script&lang=js&"
import style0 from "./FeatureTabs.vue?vue&type=style&index=0&id=5e4fe026&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports